export default __webpack_public_path__ + "static/media/ai_processing.1be781c3.gif";